import { render, staticRenderFns } from "./TodoItems.vue?vue&type=template&id=79eed784&scoped=true&lang=pug&"
import script from "./TodoItems.vue?vue&type=script&lang=js&"
export * from "./TodoItems.vue?vue&type=script&lang=js&"
import style0 from "./TodoItems.vue?vue&type=style&index=0&id=79eed784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eed784",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
